/* eslint-disable @typescript-eslint/naming-convention */
import map from 'lodash/map';
import pushClevertapEvent from '../pushClevertapEvent';

export function libraryModifierStart({ current_outlet }) {
  pushClevertapEvent('Library Modifier Start', {
    'Current Selected Outlet': current_outlet,
  });
}

export function libraryModifierChangeOutlet({ prevOutlet, currOutlet }) {
  pushClevertapEvent('Library Modifier Change Outlet', {
    'Previous Selected Outlet': prevOutlet,
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryModifierCreate({ modifier, allOutlet }) {
  const eventName = allOutlet
    ? 'Library Modifier Create All Outlet'
    : 'Library Modifier Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: modifier.name,
    Options: modifier.options,
  });
}

export function libraryModifierUpdateOneOutlet({
  prevName,
  prevOptions,
  newName,
  newOptions,
}) {
  pushClevertapEvent('Library Modifier Update One Outlet', {
    'Old Name': prevName,
    'Old Options': prevOptions,
    'New Name': newName,
    'New Options': newOptions,
  });
}

export function libraryModifierApplyToItems({ name, options, itemNames }) {
  pushClevertapEvent('Library Modifier Apply To Items', {
    Name: name,
    Options: options,
    'Item Names': itemNames,
  });
}

export function libraryModifierApplyToAllItems({ name, options }) {
  pushClevertapEvent('Library Modifier Apply To All Items', {
    Name: name,
    Options: options,
  });
}

export function libraryModifierDelete({ name, options }) {
  pushClevertapEvent('Library Modifier Delete', {
    Name: name,
    Options: map(options, 'id'),
  });
}

export const modifierStockSuccess = (email: string) => {
  pushClevertapEvent('Modifier Stock Success', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const modifierStockImpression = (email: string) => {
  pushClevertapEvent('Modifier Stock Impression', {
    Time: new Date().toISOString(),
    Email: email,
  });
};

export const modifierStockCount = (
  modifierName: string,
  ingredientName: string
) => {
  pushClevertapEvent('Modifier Stock Count', {
    'Modifier Name': modifierName,
    'Ingredient Name': ingredientName,
  });
};
